import React from "react";
import "./style.css";

const TermsSection = ({ title, children }) => {
  return (
    <div className="px-3">
      <div className="mt-5 d-flex">
        <div className="dash"></div>
        <div>
          <h5 className="section-title">{title}</h5>
          <div
            className="lato-font text-start text-black"
            style={{ lineHeight: "1.2" }}
          >
            {children}
          </div>
        </div>
      </div>
      <hr className="separator" />
    </div>
  );
};

export default TermsSection;
